import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function ProtectedRoute(){  

    const loginObj = useSelector(state => state.loginReducer);
    const { loginResult } = loginObj;

    return loginResult?.data && loginResult?.status ? <Outlet/>:<Navigate to="/" />
}
